export default value => {
    const convertedValue = Number(value);

    return isNaN(convertedValue) ? value : convertedValue;
};
